import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/api';
import { analytics } from '../services/analytics';
import PlaylistForm from '../components/PlaylistForm';

function AddPlaylist() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    analytics.pageView('add_playlist');
  }, []);

  const handleSubmit = async (data) => {
    try {
      setIsLoading(true);
      setError(null);

      const result = await api.addPlaylist(data);

      const type = data.username ? 'xtream' : 'm3u';
      analytics.playlistCreated(result.playlist.id, type, !!data.pin);

      navigate('/');
    } catch (err) {
      setError(err.message);
      analytics.error('add_playlist_failed', { message: err.message });
    } finally {
      setIsLoading(false);
    }
  };

  if (!auth.isAuthenticated) {
    navigate('/');
    return null;
  }

  return (
    <div className="page-container">
      <h1 style={{ marginBottom: '24px' }}>Add Playlist</h1>

      {error && (
        <div className="error-message">
          {error}
          <button onClick={() => setError(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      )}

      <PlaylistForm
        onSubmit={handleSubmit}
        isLoading={isLoading}
        submitLabel="Add Playlist"
      />
    </div>
  );
}

export default AddPlaylist;
